import { TranslationKey, useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_AnnotationStatus } from '../../../../annotations/annotationStatus/S_AnnotationStatus';
import { ColumnLayout } from '../../../../common/layouts/columnLayout/ColumnLayout';
import { GROUND_TRUTH, IGroundTruth } from '../../../jobPredictions.model';

interface IAnomalyDetectionInspectorProps {
  threshold: number[] | null;
  score: number | null;
  groundTruth: IGroundTruth | null | undefined;
}

export const AnomalyDetectionInspector = ({ score, threshold, groundTruth }: IAnomalyDetectionInspectorProps): ReactElement => {
  const { t } = useTranslator();

  const getAnomalyDescription = (): [string, TranslationKey] => {
    if (!threshold || !score) {
      return ['', 'na'];
    }

    if (score < threshold[0]) {
      return ['approved', 'prediction.annotation.good'];
    }
    if (score > threshold[1]) {
      return ['rejected', 'prediction.annotation.bad'];
    }
    if (score >= threshold[0] && score <= threshold[1]) {
      return ['annotated', 'prediction.annotation.weak'];
    }

    return ['', 'na'];
  };

  const getGroundTruthDescription = (): string => {
    if (!groundTruth?.className) {
      return '';
    }

    return groundTruth.className === GROUND_TRUTH.BAD ? 'rejected' : 'approved';
  };

  const [anomalyClass, anomalyText] = getAnomalyDescription();
  const groundTruthClass = getGroundTruthDescription();
  return (
    <ColumnLayout size='sm'>
      <div className='attributes'>
        <span className='attribute'>
          {t('prediction.score')}: <S_AnnotationStatus text={score !== null ? score.toFixed(3) : t('na')} />
        </span>
      </div>
      <div className='attributes'>
        <span className='attribute'>
          {t('prediction.inference.text')}:{' '}
          <S_AnnotationStatus
            className={anomalyClass}
            text={t(anomalyText)}
          />
        </span>
      </div>
      <div className='attributes'>
        <span className='attribute'>
          {t('prediction.annotation.text')}:{' '}
          <S_AnnotationStatus
            className={groundTruthClass}
            text={groundTruth?.className ? t(`prediction.annotation.${groundTruth.className.toLowerCase()}` as TranslationKey) : t('na')}
          />
        </span>
      </div>
    </ColumnLayout>
  );
};
